import { gql, useMutation } from "@apollo/client";

const SAVE_PRODUCT_ANSWER=gql`
mutation SaveProductAnswers($orderId: Int, $token: String, $questions: [saveProductAnswersQuestionsData]) {
    saveProductAnswers(orderId: $orderId, token: $token, questions: $questions) {
      success
      message
      data {
        orderId
      }
    }
  }
`;

export const SaveProductAnswersActions=()=>{
    const [saveProductAnswerResponseFunction,
    saveProductAnswerResponseData]=useMutation(SAVE_PRODUCT_ANSWER)

    const saveProductAnswerQueryData=saveProductAnswerResponseData;

    const initSaveProductAnswerData=(data, successCallback, errorCallback)=>{
        saveProductAnswerResponseFunction({
            variables:data
        }).then((responseData)=>{
            if(responseData.data.saveProductAnswers.success){
                successCallback(responseData)
            }else{
                errorCallback(responseData)
            }
        }).catch((error)=>{
            errorCallback(error)
        })
    }

    return {initSaveProductAnswerData,saveProductAnswerQueryData}
}